// src/routes/AdminRoutes.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import ResponsiveDrawer from "../components/sidebar";
import RequirePermission from "./RequirePermission";
import Phases from "../screens/user/phases";
import Dashboard from "../screens/user/dashboard";
import ProjectDetailPage from "../screens/user/ProjectDetails";
import ViewTimeSheet from "../screens/user/time/container/Timesheet";
import Expenses from "../screens/expenses";
import Profile from "../screens/profile";
import TimeReport from "../screens/admin/timeReport/TimeReport";
import AddExpense from "../screens/expenses/add";
import ExpenseReport from "../screens/expenses/report";

// The personal shell. Most of it is the caller's own data, which needs no
// permission — your dashboard, your profile, your expenses. The guarded
// screens are the ones that read or write something beyond yourself.
function UsersRoutes() {
  return (
    <ResponsiveDrawer>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/phases"
          element={
            <RequirePermission permission="projects.view">
              <Phases />
            </RequirePermission>
          }
        />
        <Route
          path="/time/add"
          element={
            <RequirePermission permission="timesheets.create">
              <ViewTimeSheet />
            </RequirePermission>
          }
        />
        <Route path="/project-details" element={<ProjectDetailPage />} />
        <Route path="/view-time-sheet/:id" element={<ViewTimeSheet />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route
          path="/expenses/report"
          element={
            <RequirePermission permission="reports.expense">
              <ExpenseReport />
            </RequirePermission>
          }
        />
        <Route path="/expenses/add" element={<AddExpense />} />
        <Route path="/expenses/:expenseId/edit" element={<AddExpense />} />
        {/* Reading the team's hours rather than only your own. This was the
            Manager role's one extra screen; it now follows the permission, so
            any role granted reports.time gets it. */}
        <Route
          path="/time-report"
          element={
            <RequirePermission permission="reports.time">
              <TimeReport />
            </RequirePermission>
          }
        />
      </Routes>
    </ResponsiveDrawer>
  );
}

export default UsersRoutes;
